import Svg, { ClipPath, Defs, G, Path, Rect, SvgProps } from 'react-native-svg'

export const LoginBlocked = (props: SvgProps) => {
  return (
    <Svg width={251} height={250} viewBox="0 0 251 250" fill="none">
      <G clipPath="url(#clip0_8462_168482)">
        <Path
          d="M220.69 103.58V68.43C220.69 66.25 219.82 64.16 218.28 62.62C216.74 61.08 214.65 60.21 212.47 60.21H51.5501C49.3701 60.21 47.2801 61.08 45.7401 62.62C44.2001 64.16 43.3301 66.25 43.3301 68.43V184.14C43.3301 186.32 44.2001 188.41 45.7401 189.95C47.2801 191.49 49.3701 192.36 51.5501 192.36H212.48C214.66 192.36 216.75 191.49 218.29 189.95C219.83 188.41 220.7 186.32 220.7 184.14V103.58H220.69Z"
          fill="#F5F5F5"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M55.16 68.98C54.56 68.98 53.97 69.16 53.47 69.49C52.97 69.82 52.58 70.3 52.35 70.85C52.12 71.41 52.06 72.02 52.18 72.61C52.3 73.2 52.59 73.74 53.01 74.17C53.44 74.6 53.98 74.88 54.57 75C55.16 75.12 55.77 75.06 56.33 74.83C56.89 74.6 57.36 74.21 57.69 73.71C58.02 73.21 58.2 72.62 58.2 72.02C58.2 71.62 58.12 71.22 57.97 70.86C57.82 70.49 57.59 70.16 57.31 69.87C57.03 69.59 56.69 69.36 56.32 69.21C55.95 69.06 55.55 68.98 55.16 68.98V68.98Z"
          fill="#F3123C"
        />
        <Path
          d="M220.69 83.73H43.3301"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M58.2 72.02C58.2 72.62 58.02 73.21 57.69 73.71C57.36 74.21 56.88 74.6 56.33 74.83C55.77 75.06 55.16 75.12 54.57 75C53.98 74.88 53.44 74.59 53.01 74.17C52.58 73.74 52.3 73.2 52.18 72.61C52.06 72.02 52.12 71.41 52.35 70.85C52.58 70.29 52.97 69.82 53.47 69.49C53.97 69.16 54.56 68.98 55.16 68.98C55.56 68.98 55.96 69.06 56.32 69.21C56.69 69.36 57.02 69.59 57.31 69.87C57.59 70.15 57.82 70.49 57.97 70.86C58.12 71.23 58.2 71.63 58.2 72.02V72.02Z"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M67.3602 72.02C67.3602 72.62 67.1802 73.21 66.8502 73.71C66.5202 74.21 66.0402 74.6 65.4902 74.83C64.9302 75.06 64.3202 75.12 63.7302 75C63.1402 74.88 62.6002 74.59 62.1702 74.17C61.7402 73.74 61.4602 73.2 61.3402 72.61C61.2202 72.02 61.2802 71.41 61.5102 70.85C61.7402 70.29 62.1302 69.82 62.6302 69.49C63.1302 69.16 63.7202 68.98 64.3202 68.98C64.7202 68.98 65.1202 69.06 65.4802 69.21C65.8502 69.36 66.1802 69.59 66.4702 69.87C66.7502 70.15 66.9802 70.49 67.1302 70.86C67.2802 71.23 67.3602 71.63 67.3602 72.02V72.02Z"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M76.5501 72.02C76.5501 72.62 76.3701 73.21 76.0401 73.71C75.7101 74.21 75.2301 74.6 74.6801 74.83C74.1201 75.06 73.5101 75.12 72.9201 75C72.3301 74.88 71.7901 74.59 71.3601 74.17C70.9301 73.74 70.6501 73.2 70.5301 72.61C70.4101 72.02 70.4701 71.41 70.7001 70.85C70.9301 70.29 71.3201 69.82 71.8201 69.49C72.3201 69.16 72.9101 68.98 73.5101 68.98C73.9101 68.98 74.3101 69.06 74.6701 69.21C75.0401 69.36 75.3701 69.59 75.6601 69.87C75.9401 70.15 76.1701 70.49 76.3201 70.86C76.4701 71.23 76.5501 71.63 76.5501 72.02V72.02Z"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M132.38 183.02C155.786 183.02 174.76 164.046 174.76 140.64C174.76 117.234 155.786 98.26 132.38 98.26C108.974 98.26 90 117.234 90 140.64C90 164.046 108.974 183.02 132.38 183.02Z"
          fill="#F5F5F5"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M131.87 111.7C129.97 111.7 128.12 112.26 126.54 113.32C124.96 114.38 123.73 115.87 123.01 117.63C122.28 119.38 122.09 121.31 122.46 123.17C122.83 125.03 123.74 126.74 125.09 128.08C126.44 129.42 128.14 130.33 130 130.71C131.86 131.08 133.79 130.89 135.54 130.16C137.29 129.43 138.79 128.2 139.85 126.63C140.91 125.05 141.47 123.2 141.47 121.3C141.47 118.76 140.46 116.32 138.66 114.52C136.86 112.72 134.42 111.71 131.88 111.71L131.87 111.7Z"
          fill="#F3123C"
        />
        <Path
          d="M141.46 121.3C141.46 123.2 140.9 125.05 139.84 126.63C138.79 128.21 137.29 129.44 135.53 130.16C133.78 130.89 131.85 131.08 129.99 130.71C128.13 130.34 126.42 129.43 125.08 128.08C123.74 126.73 122.82 125.03 122.45 123.17C122.08 121.31 122.27 119.38 123 117.63C123.73 115.88 124.96 114.38 126.53 113.32C128.11 112.27 129.96 111.7 131.86 111.7C134.4 111.7 136.85 112.71 138.64 114.51C140.44 116.31 141.45 118.75 141.45 121.29L141.46 121.3Z"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M112.42 178.06C106.23 174.8 100.94 170.06 97.03 164.26C93.12 158.46 90.7 151.78 90 144.81"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M104.35 166.05C107.36 153.57 118.6 144.29 132 144.29C145.4 144.29 157.14 153.98 159.84 166.88"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M151.86 163.5L112.34 163.67L112.44 180.11C112.44 182.72 112.94 185.3 113.94 187.71C114.93 190.12 116.4 192.31 118.24 194.15C120.08 195.99 122.28 197.45 124.68 198.44C127.09 199.43 129.67 199.94 132.28 199.93C134.89 199.92 137.46 199.39 139.87 198.38C142.27 197.37 144.45 195.89 146.28 194.03C148.11 192.17 149.55 189.97 150.53 187.56C151.51 185.14 151.99 182.56 151.96 179.95L151.86 163.51V163.5Z"
          fill="#F3123C"
        />
        <Path
          d="M150.2 148.87C149.2 149.09 148.16 149.13 147.14 148.98C147.12 148.98 147.1 148.98 147.08 148.97C146.95 148.96 146.84 148.95 146.72 148.92C146.37 148.86 146.04 148.78 145.74 148.65C145.3 148.47 144.9 148.2 144.57 147.85C143.86 146.86 143.04 145.97 142.12 145.18C141.9 144.98 141.66 144.79 141.42 144.61C140.97 144.26 140.5 143.94 140.01 143.65C139.93 143.6 139.86 143.56 139.78 143.51C139.66 143.43 139.53 143.36 139.4 143.29C139.39 143.28 139.38 143.28 139.37 143.27C139.29 143.23 139.21 143.19 139.12 143.15C138.85 143.01 138.58 142.88 138.3 142.76C138.07 142.65 137.84 142.56 137.61 142.47C137.4 142.39 137.19 142.32 136.98 142.25C136.6 142.11 136.22 142 135.83 141.91C135.53 141.83 135.22 141.76 134.92 141.71C134.66 141.66 134.4 141.61 134.15 141.58C133.81 141.53 133.47 141.5 133.14 141.48C132.92 141.47 132.7 141.46 132.47 141.45C132.33 141.45 132.19 141.45 132.05 141.45C131.71 141.45 131.37 141.45 131.04 141.48H131.03C130.71 141.5 130.4 141.53 130.09 141.57C129.82 141.6 129.55 141.64 129.28 141.69C129.05 141.73 128.82 141.78 128.6 141.83C128.56 141.83 128.52 141.85 128.48 141.86C127.9 142 127.33 142.17 126.77 142.37C126.49 142.46 126.21 142.57 125.94 142.7C125.52 142.86 125.11 143.06 124.71 143.27C124.7 143.27 124.7 143.28 124.69 143.28C122.95 144.21 121.41 145.47 120.17 147C119.99 147.23 119.81 147.44 119.64 147.68C119.63 147.69 119.62 147.71 119.61 147.72C119.18 148.27 118.58 148.66 117.9 148.81C116.61 149.17 115.25 149.2 113.94 148.91C114.28 148.13 114.67 147.37 115.1 146.65C115.25 146.4 115.41 146.16 115.57 145.92C115.68 145.74 115.8 145.57 115.93 145.39C115.93 145.37 115.93 145.36 115.95 145.35C116.07 145.18 116.2 145.01 116.33 144.85C116.42 144.72 116.52 144.6 116.62 144.48C116.66 144.41 116.72 144.35 116.77 144.29C116.91 144.09 117.06 143.89 117.22 143.71C118.14 142.67 119.17 141.74 120.27 140.96C120.67 140.67 121.09 140.39 121.52 140.12C121.65 140.04 121.78 139.96 121.91 139.89C122.14 139.75 122.38 139.61 122.62 139.49C125.3 138.08 128.29 137.31 131.32 137.2C131.8 137.18 132.27 137.19 132.75 137.2C132.96 137.21 133.17 137.22 133.37 137.23C133.63 137.25 133.88 137.27 134.13 137.29C134.16 137.3 134.19 137.3 134.21 137.3C134.59 137.34 134.96 137.39 135.33 137.46C135.36 137.46 135.39 137.46 135.42 137.47C135.8 137.54 136.17 137.61 136.54 137.7C136.91 137.78 137.28 137.87 137.64 137.98C139.2 138.43 140.7 139.07 142.1 139.89C142.45 140.1 142.8 140.31 143.14 140.54C143.59 140.84 144.02 141.16 144.44 141.49C144.75 141.73 145.04 141.98 145.33 142.24C145.54 142.42 145.73 142.6 145.93 142.81C145.98 142.84 146.04 142.9 146.09 142.97C146.34 143.21 146.58 143.46 146.81 143.72C146.81 143.72 146.817 143.726 146.83 143.74C147.18 144.12 147.51 144.52 147.82 144.92C147.98 145.13 148.13 145.33 148.28 145.54C148.43 145.75 148.58 145.96 148.72 146.18C148.86 146.39 148.99 146.61 149.13 146.83C149.26 147.05 149.39 147.26 149.51 147.49C149.76 147.94 149.99 148.4 150.2 148.87V148.87Z"
          fill="#404040"
        />
        <Path
          d="M116.9 154.91C116.84 155.53 116.81 156.13 116.81 156.74V163.65L112.34 163.67V156.9C112.34 156.12 112.39 155.34 112.46 154.58C112.52 154.59 112.59 154.61 112.66 154.62C112.87 154.67 113.09 154.71 113.3 154.74C113.58 154.79 113.86 154.83 114.14 154.86C114.42 154.89 114.71 154.91 114.99 154.93C115.63 154.96 116.27 154.95 116.9 154.91Z"
          fill="#404040"
        />
        <Path
          d="M151.87 156.73V163.5H151.84L147.49 163.52V156.61C147.49 156.32 147.48 156.04 147.46 155.76C147.45 155.48 147.42 155.2 147.4 154.92C147.55 154.93 147.69 154.94 147.84 154.93C148.32 154.96 148.8 154.95 149.28 154.92C149.57 154.9 149.87 154.87 150.16 154.83C150.34 154.81 150.51 154.78 150.68 154.76C150.85 154.73 151.03 154.7 151.21 154.66C151.38 154.63 151.56 154.59 151.74 154.55C151.78 154.9 151.81 155.27 151.83 155.63C151.85 156 151.86 156.36 151.87 156.73V156.73Z"
          fill="#404040"
        />
        <Path
          d="M135.72 173.71C135.72 173.51 135.64 173.33 135.5 173.19C135.36 173.05 135.18 172.98 134.98 172.97L129.36 172.99C129.16 172.99 128.98 173.07 128.84 173.21C128.7 173.35 128.63 173.53 128.62 173.73L128.67 184.96C128.67 185.16 128.75 185.34 128.89 185.48C129.03 185.62 129.21 185.69 129.41 185.7L135.03 185.68C135.22 185.68 135.41 185.6 135.55 185.46C135.69 185.32 135.77 185.14 135.77 184.94L135.72 173.71V173.71Z"
          fill="#404040"
        />
        <Path
          d="M151.86 163.5L112.34 163.67L112.44 180.11C112.44 182.72 112.94 185.3 113.94 187.71C114.93 190.12 116.4 192.31 118.24 194.15C120.08 195.99 122.28 197.45 124.68 198.44C127.09 199.43 129.67 199.94 132.28 199.93C134.89 199.92 137.46 199.39 139.87 198.38C142.27 197.37 144.45 195.89 146.28 194.03C148.11 192.17 149.55 189.97 150.53 187.56C151.51 185.14 151.99 182.56 151.96 179.95L151.86 163.51V163.5Z"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M150.2 148.87C149.99 148.4 149.76 147.94 149.51 147.49C149.39 147.26 149.26 147.05 149.13 146.83C149 146.61 148.87 146.39 148.72 146.18C148.59 145.96 148.44 145.75 148.28 145.54C148.14 145.33 147.99 145.12 147.82 144.92C147.52 144.51 147.19 144.12 146.83 143.74C146.83 143.74 146.823 143.733 146.81 143.72"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M145.93 142.81C145.73 142.6 145.53 142.42 145.33 142.24C145.04 141.98 144.75 141.73 144.44 141.49"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M120.27 140.95C119.16 141.77 118.15 142.69 117.25 143.72C117.08 143.9 116.92 144.09 116.77 144.28"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M121.91 139.88C122.14 139.74 122.38 139.6 122.62 139.48C125.3 138.04 128.28 137.26 131.32 137.19C131.8 137.17 132.27 137.18 132.75 137.2C132.96 137.21 133.17 137.22 133.37 137.23C133.63 137.25 133.88 137.27 134.13 137.29C134.16 137.3 134.19 137.3 134.21 137.3C134.59 137.34 134.96 137.39 135.33 137.46C135.36 137.46 135.39 137.46 135.42 137.47C135.8 137.53 136.17 137.61 136.54 137.7C136.91 137.78 137.28 137.87 137.64 137.98C139.2 138.43 140.7 139.07 142.1 139.89"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M139.36 143.28C139.28 143.23 139.2 143.19 139.12 143.15C138.85 143.01 138.58 142.88 138.3 142.76C138.07 142.65 137.84 142.56 137.61 142.47C137.4 142.39 137.19 142.31 136.98 142.25C136.6 142.11 136.22 142 135.83 141.91C135.53 141.83 135.22 141.76 134.92 141.71C134.66 141.66 134.4 141.61 134.15 141.58C133.81 141.53 133.47 141.5 133.14 141.48C132.8 141.45 132.47 141.43 132.13 141.43C131.76 141.43 131.4 141.44 131.04 141.47H131.03C130.71 141.49 130.4 141.52 130.09 141.56C129.82 141.59 129.55 141.63 129.28 141.68C129.05 141.72 128.82 141.77 128.6 141.82L128.48 141.85C127.9 141.99 127.33 142.16 126.77 142.36C126.49 142.46 126.21 142.57 125.94 142.69C125.66 142.81 125.39 142.94 125.12 143.07C124.99 143.14 124.85 143.21 124.72 143.28"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M116.9 154.91C116.83 155.52 116.8 156.13 116.8 156.74V163.65L112.34 163.67V156.9C112.34 156.12 112.39 155.33 112.46 154.57"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M151.74 154.55C151.81 155.26 151.86 156 151.86 156.73V163.5L147.48 163.52V156.61C147.48 156.04 147.43 155.47 147.38 154.92"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M135.74 184.95L135.72 173.74C135.72 173.54 135.64 173.36 135.5 173.22C135.36 173.08 135.18 173.01 134.98 173L129.36 173.02C129.17 173.02 128.98 173.1 128.84 173.24C128.7 173.38 128.62 173.56 128.62 173.76L128.67 184.97C128.67 185.17 128.75 185.35 128.89 185.49C129.03 185.63 129.21 185.7 129.41 185.71L135.02 185.69C135.21 185.69 135.4 185.61 135.54 185.47C135.68 185.33 135.75 185.14 135.76 184.95H135.74Z"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M72.3501 123.46V123.48C72.2401 126.6 70.9501 129.58 68.7501 131.8C66.8401 130.01 65.3901 127.95 65.7201 126.12L66.0501 125.34C66.4001 124.26 66.5301 123.12 66.4101 121.99C66.3001 120.87 65.9501 119.78 65.4001 118.8C65.4001 118.79 65.3901 118.79 65.3901 118.78C62.4701 112.96 54.9901 108.97 48.1201 108.97C43.4001 108.97 39.4101 110.83 38.0501 114.15C35.9901 119.21 40.6501 126.07 48.2201 129.16C52.0601 130.82 56.3401 131.15 60.3901 130.08C60.9401 131.5 61.8401 132.96 63.1401 134.44C63.3301 134.67 63.5401 134.9 63.7401 135.12C53.6701 139.3 39.9801 134.22 34.2801 125.08C28.6101 116 32.6201 106.17 43.0201 103.65C53.7301 101.07 67.2901 107.31 71.3101 117.57C71.3101 117.59 71.3101 117.6 71.3301 117.62C72.0601 119.48 72.4001 121.47 72.3501 123.46V123.46Z"
          fill="#F5F5F5"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M68.7502 131.8C68.7502 131.8 68.7302 131.83 68.7202 131.84"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M98.5001 136.1C98.4501 138.25 97.5701 140.29 95.7301 141.9H95.7201C95.7201 141.9 95.7101 141.89 95.7001 141.89C92.9901 140.04 91.8501 137.92 92.2001 137.07H92.2101L92.4901 136.64C93.0601 135.25 91.9401 133.09 90.3001 131.29C90.2801 131.28 90.2701 131.26 90.2601 131.25C86.1101 126.72 78.3501 123.57 72.3501 123.48V123.46C72.4001 121.47 72.0601 119.48 71.3301 117.62C80.2001 117.32 91.9801 122.47 96.6801 130.03V130.04C97.9001 131.99 98.5501 134.1 98.4901 136.1H98.5001Z"
          fill="#F5F5F5"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M71.3301 117.62H71.3101"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M65.4199 118.79C65.4199 118.79 65.4199 118.79 65.3999 118.79"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M89.6803 144.53C81.0503 146.03 69.9103 141.85 63.7503 135.12H63.7403C63.5403 134.9 63.3303 134.67 63.1403 134.44C61.8403 132.96 60.9403 131.5 60.3903 130.08C58.4403 125.07 60.8503 120.68 65.4003 118.8C65.9503 119.78 66.3003 120.87 66.4103 121.99C66.5303 123.12 66.4003 124.26 66.0503 125.34L65.7203 126.12C65.3903 127.95 66.8403 130.01 68.7503 131.8C70.4703 133.42 72.5603 134.81 74.0403 135.63C77.8403 137.71 82.0803 138.84 86.4103 138.95C86.8403 141.04 88.0503 142.92 89.6803 144.53V144.53Z"
          fill="#F5F5F5"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M89.7102 144.53H89.6802"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M60.4701 130.06C60.4701 130.06 60.4201 130.06 60.3901 130.08"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M86.4501 138.95H86.4102"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M114.12 142.44C114.16 142.71 114.18 142.99 114.2 143.27C114.2 144.21 114.01 145.15 113.62 146.02C113.24 146.88 112.68 147.65 111.97 148.28"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M119.61 147.71C118.76 149.07 116.19 149.33 113.85 148.95C113.63 148.92 113.41 148.87 113.2 148.8C110.91 148.03 107.61 145.77 107.97 143.98H107.98C108.16 143.82 108.3 143.6 108.33 143.38V143.36C108.4 142.36 107.19 140.44 104.67 138.73C102.86 137.52 100.65 136.57 98.4999 136.1C98.5599 134.1 97.9099 131.99 96.6899 130.04V130.03C102.03 130.37 107.16 132.61 111 136.33C111.01 136.34 111.02 136.35 111.03 136.36C112.72 137.99 113.8 140.13 114.13 142.44C115.18 142.68 116.31 143.13 117.23 143.7C117.07 143.88 116.92 144.08 116.78 144.28C116.73 144.34 116.67 144.4 116.63 144.47C116.53 144.59 116.43 144.71 116.34 144.84C116.21 145 116.08 145.17 115.96 145.34C115.95 145.35 115.94 145.36 115.94 145.38C115.81 145.56 115.69 145.73 115.58 145.91C115.41 146.15 115.26 146.39 115.11 146.64C114.68 147.36 114.29 148.12 113.95 148.9C115.26 149.19 116.62 149.16 117.91 148.8C118.59 148.65 119.19 148.26 119.62 147.71H119.61Z"
          fill="#F5F5F5"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M96.6798 130.03C96.6798 130.03 96.6198 130.02 96.5898 130.02"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M98.5 136.1C98.43 136.08 98.36 136.06 98.29 136.05"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M107.97 143.98H107.96"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M90.4203 131.23L90.3003 131.29"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M104.93 150.68H105.1"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M72.3501 123.48H72.3101"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M104.93 150.68C102.11 150.69 99.31 150.13 96.69 149.04C94.19 148.01 91.63 146.47 89.68 144.53C88.05 142.92 86.84 141.04 86.41 138.95C86.07 137.42 86.31 135.83 86.99 134.42C87.66 133.06 88.93 131.96 90.3 131.29C91.94 133.09 93.06 135.25 92.49 136.64L92.21 137.07H92.2C91.85 137.92 92.99 140.04 95.7 141.89C95.71 141.89 95.71 141.9 95.72 141.91H95.73C97.61 143.17 99.89 144.08 102.13 144.53C102.19 146.67 103.16 148.87 104.93 150.68V150.68Z"
          fill="#F5F5F5"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M102.15 144.53H102.13H102.16"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M95.7302 141.9H95.7202"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M114.14 154.86C114.43 154.9 114.71 154.92 114.99 154.93C115.65 154.97 116.28 154.96 116.9 154.92"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M124.72 143.28C124.72 143.28 124.71 143.27 124.71 143.26C124.71 143.25 124.7 143.25 124.7 143.24"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M104.7 138.71C104.7 138.71 104.68 138.73 104.67 138.73"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M116.9 154.91C116.27 154.95 115.63 154.96 114.99 154.93C114.71 154.91 114.42 154.89 114.14 154.86C113.86 154.83 113.58 154.79 113.3 154.74C113.09 154.71 112.87 154.67 112.66 154.62C112.59 154.61 112.52 154.59 112.46 154.58C112 154.47 111.54 154.35 111.07 154.2C108.49 153.48 106.42 152.22 104.93 150.68C103.16 148.87 102.19 146.67 102.13 144.53C102.06 142.41 102.87 140.33 104.67 138.73C107.19 140.44 108.4 142.36 108.33 143.36V143.38C108.18 143.55 108.03 143.77 107.98 143.97H107.97C107.61 145.77 110.91 148.03 113.2 148.8C113.41 148.87 113.63 148.92 113.85 148.95C116.19 149.33 118.76 149.07 119.61 147.71C119.62 147.7 119.63 147.68 119.64 147.67C119.81 147.43 119.99 147.22 120.17 146.99C121.44 145.48 122.98 144.21 124.72 143.28C127.7 149.02 123.52 154.38 116.9 154.91V154.91Z"
          fill="#F5F5F5"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M108.39 143.3C108.39 143.3 108.35 143.35 108.33 143.38"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M121.91 139.88C121.78 139.95 121.65 140.03 121.52 140.11C121.09 140.38 120.67 140.66 120.27 140.95C119.17 141.73 118.14 142.66 117.22 143.7C116.3 143.13 115.17 142.68 114.12 142.44C113.79 140.13 112.71 137.99 111.02 136.36C114.96 136.14 118.84 137.4 121.91 139.88V139.88Z"
          fill="#F5F5F5"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M121.94 139.9C121.94 139.9 121.92 139.88 121.91 139.88"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M111.02 136.36H110.99"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M114.12 142.44C114.12 142.44 114.09 142.43 114.07 142.43"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M117.22 143.7C117.22 143.7 117.24 143.71 117.25 143.72L117.31 143.75"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M229.81 125.08C224.12 134.21 210.44 139.29 200.37 135.13C200.57 134.9 200.76 134.67 200.95 134.43C202.18 133.09 203.16 131.62 203.76 130.09C207.79 131.14 212.04 130.81 215.87 129.16C229.47 123.62 230.54 108.97 215.96 108.97C209.1 108.97 201.62 112.96 198.7 118.78C198.68 118.81 198.67 118.83 198.66 118.86C198.03 119.95 197.68 121.16 197.62 122.41C197.57 123.69 197.83 124.97 198.39 126.12C198.72 127.88 197.06 130.21 195.37 131.84C193.19 129.64 191.86 126.75 191.75 123.48C191.67 121.63 191.99 119.65 192.77 117.61C192.77 117.6 192.77 117.58 192.78 117.57C196.8 107.31 210.36 101.07 221.07 103.65C231.47 106.17 235.48 116 229.81 125.08V125.08Z"
          fill="#F5F5F5"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M200.37 135.13C200.37 135.13 200.35 135.12 200.34 135.12"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M168.36 141.91L168.35 141.9"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M192.77 117.61C191.99 119.65 191.67 121.63 191.75 123.48C185.76 123.59 178 126.72 173.85 131.23L173.83 131.25C172.36 132.85 170.79 135.19 171.88 137.07C172.36 138.21 170.85 140.21 168.35 141.9C166.69 140.43 165.68 138.43 165.6 136.14C165.52 134.26 166.07 132.17 167.4 130.04C167.41 130.03 167.41 130.02 167.42 130.01C172.12 122.47 183.91 117.33 192.77 117.61V117.61Z"
          fill="#F5F5F5"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M192.84 117.61H192.77"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M191.83 123.48H191.75"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M203.76 130.09C203.71 130.08 203.67 130.07 203.62 130.06"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M177.63 138.95C184.2 138.77 190.5 136.25 195.37 131.84"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M174.38 144.53C183.01 146.02 194.75 141.57 200.37 135.13"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M203.76 130.09C204.6 127.96 204.7 125.72 203.68 123.56C203.22 122.46 202.53 121.48 201.67 120.66C200.86 119.89 199.72 119.28 198.66 118.86C198.59 118.83 198.53 118.8 198.46 118.78"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M155.77 143.39C155.78 143.5 155.81 143.61 155.86 143.71C155.92 143.81 156 143.91 156.1 143.98"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M167.4 130.04C166.07 132.17 165.52 134.26 165.6 136.14C163.08 136.67 161 137.64 159.41 138.72C156.97 140.38 155.69 142.32 155.76 143.36C155.76 143.37 155.76 143.38 155.77 143.39C155.92 143.56 156.06 143.76 156.12 143.98C156.45 145.63 154.07 147.44 152.15 148.28C151.45 147.67 150.84 146.87 150.47 146.01C150.08 145.15 149.89 144.21 149.89 143.27C149.91 142.98 149.93 142.7 149.97 142.42C150.3 140.1 151.4 137.96 153.1 136.33C153.1 136.33 153.107 136.323 153.12 136.31C156.97 132.59 162.07 130.36 167.42 130.01C167.41 130.02 167.41 130.03 167.4 130.04V130.04Z"
          fill="#F5F5F5"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M152.18 148.31L152.15 148.28"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M167.46 130.01H167.42"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M177.63 138.95C176.42 144.8 167.91 150.83 159 150.68C160.7 149.03 161.87 146.95 161.98 144.57V144.55C164.36 144.1 166.6 143.08 168.35 141.9C170.85 140.21 172.36 138.21 171.88 137.07C170.79 135.19 172.36 132.85 173.83 131.25L173.85 131.23C175.26 131.89 176.41 133.02 177.1 134.42C177.78 135.83 177.97 137.42 177.63 138.95V138.95Z"
          fill="#F5F5F5"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M173.85 131.23L173.84 131.22"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M161.98 144.55C161.98 144.55 161.96 144.56 161.95 144.56"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M147.14 148.98C148.13 149.11 149.23 149.05 150.2 148.87"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M155.77 143.39L155.74 143.36"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M161.98 144.55V144.57C161.87 146.95 160.7 149.03 159 150.68H158.99C157.4 152.24 155.34 153.42 153.25 154.13C152.75 154.3 152.24 154.44 151.74 154.55C151.56 154.59 151.38 154.63 151.21 154.66C151.04 154.7 150.86 154.73 150.68 154.76C150.51 154.78 150.34 154.81 150.16 154.83C149.86 154.87 149.57 154.9 149.28 154.92C148.79 154.94 148.31 154.95 147.84 154.93C142.68 154.75 138.4 151.81 138.4 147.02C138.42 145.71 138.75 144.44 139.36 143.28C139.5 143.35 139.64 143.43 139.78 143.51C139.86 143.56 139.93 143.6 140.01 143.65C140.5 143.94 140.97 144.26 141.42 144.61C141.66 144.79 141.89 144.98 142.12 145.18C143.04 145.97 143.86 146.86 144.57 147.85C144.85 148.2 145.25 148.47 145.74 148.65C146.04 148.78 146.37 148.86 146.72 148.92C146.84 148.95 146.95 148.96 147.08 148.97C147.1 148.98 147.12 148.98 147.14 148.98C148.16 149.13 149.2 149.09 150.2 148.87C150.7 148.78 151.16 148.66 151.56 148.52C151.75 148.45 151.95 148.38 152.15 148.28C154.07 147.44 156.45 145.63 156.12 143.98C156.06 143.76 155.92 143.56 155.77 143.39C155.76 143.39 155.76 143.37 155.76 143.36C155.69 142.32 156.97 140.38 159.41 138.72C160.25 139.42 160.95 140.35 161.39 141.35C161.83 142.36 162.04 143.46 161.98 144.55V144.55Z"
          fill="#F5F5F5"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M139.37 143.27C139.37 143.27 139.37 143.28 139.36 143.28"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M159.41 138.72L159.38 138.69"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M153.12 136.31C153.12 136.31 153.11 136.32 153.1 136.33C151.4 137.96 150.3 140.1 149.97 142.42C148.9 142.67 147.74 143.15 146.81 143.72C146.59 143.46 146.34 143.2 146.09 142.97C146.04 142.9 145.98 142.84 145.93 142.81C145.73 142.6 145.54 142.42 145.33 142.24C145.04 141.98 144.75 141.73 144.44 141.49C144.02 141.16 143.59 140.84 143.14 140.54C142.8 140.31 142.45 140.1 142.1 139.89C145.16 137.4 149.18 136.1 153.12 136.31V136.31Z"
          fill="#F5F5F5"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M142.1 139.89C142.1 139.89 142.08 139.89 142.07 139.91"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M153.17 136.31H153.12"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M150.04 142.4C150.04 142.4 149.99 142.41 149.97 142.42"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M146.81 143.72C146.81 143.72 146.79 143.72 146.78 143.74"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M14.1904 136.59L14.1704 152.03"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M21.8802 144.31L6.47021 144.29"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M243.92 83.2501C244.02 83.6601 243.99 84.0901 243.84 84.4801C243.69 84.8701 243.43 85.2101 243.08 85.4601C242.74 85.7001 242.33 85.8401 241.91 85.8501C241.49 85.8601 241.08 85.7501 240.72 85.5301C240.36 85.3101 240.08 84.9801 239.91 84.6001C239.74 84.2201 239.68 83.7901 239.76 83.3801C239.83 82.9701 240.02 82.5801 240.31 82.2801C240.6 81.9701 240.97 81.7601 241.38 81.6701C241.93 81.5501 242.5 81.6401 242.98 81.9401C243.46 82.2401 243.8 82.7101 243.92 83.2601V83.2501Z"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M168.75 213.45V218.82"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M179.19 223.88H173.82"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M168.75 234.32V228.96"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M158.31 223.88H163.68"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M173.82 223.88C173.15 223.88 172.49 223.75 171.88 223.5C171.26 223.24 170.7 222.87 170.23 222.4C169.76 221.93 169.38 221.37 169.13 220.75C168.87 220.13 168.74 219.47 168.75 218.81C168.75 219.48 168.62 220.14 168.37 220.75C168.12 221.37 167.74 221.93 167.27 222.4C166.8 222.87 166.24 223.25 165.62 223.5C165.01 223.75 164.35 223.89 163.68 223.88C164.35 223.88 165.01 224.01 165.62 224.26C166.24 224.52 166.8 224.89 167.27 225.36C167.74 225.83 168.12 226.39 168.37 227.01C168.62 227.63 168.75 228.29 168.75 228.95C168.75 228.28 168.88 227.62 169.13 227.01C169.38 226.39 169.76 225.83 170.23 225.36C170.7 224.89 171.26 224.51 171.88 224.26C172.5 224.01 173.16 223.87 173.82 223.88Z"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M145.43 22.76C140.81 21.05 136.34 18.94 132.08 16.47C127.76 18.82 123.33 20.94 118.78 22.81L118.8 28.58C118.82 36.56 124.21 45.58 132.19 48.67C140.36 45.47 145.49 36.27 145.47 28.51L145.42 22.76H145.43Z"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M126.86 29.82L132.18 37.21L137.4 27.95"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_8462_168482">
          <Rect width={238.44} height={218.79} fill="white" transform="translate(6 16)" />
        </ClipPath>
      </Defs>
    </Svg>
  )
}
